import { createContext, useContext, useState, useEffect } from "react";
import api, { setSellerToken } from "../core/api/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [seller,  setSeller]  = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/seller/auth/me")
      .then(r => setSeller(r.data.seller))
      .catch(() => setSeller(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/seller/auth/login", { email, password });
    if (r.data.token) setSellerToken(r.data.token);   // for Bearer auth (iPhone etc.)
    setSeller(r.data.seller);
    return r.data.seller;
  };

  const logout = async () => {
    try { await api.post("/seller/auth/logout"); } catch {}
    setSellerToken(null);
    setSeller(null);
    window.location.href = "/login";
  };

  const refresh = async () => {
    const r = await api.get("/seller/auth/me");
    setSeller(r.data.seller);
  };

  return (
    <AuthContext.Provider value={{ seller, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
